import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';

export default class NewTotpController extends Controller {
  @service alerts;
  @service router;
  @service auth;

  queryParams = ['regenerating'];
  regenerating = null; // null or true
  serverErrors = null;
  _canFinish = false;

  @action
  resetServerErrors() {
    this.set('serverErrors', []);
  }

  @action
  setupTwoFactorAuthentication(code) {
    return this.model.user
      .setupTwoFactorAuthentication({ code, secret: this.model.secret })
      .then(() => this.model.user.reload()) // refresh current user to reflect new 2FA status
      .then(() => {
        this.alerts.success('user.twoAuthConfirmBackupCodes.success', 'Two-factor authentication is now enabled');
        // Prevents 2FA enabled users to have session expiration time
        return this.router.transitionTo('settings.personal.security');
      })
      .catch((err) => {
        if (err.errors?.[0]?.status === '400') {
          return this.set('serverErrors', ['Your authentication code is invalid. Try again?']);
        }
        throw err;
      });
  }
}
